import { CHAIN } from '~/constants/default.constants'

export interface ISeoMetaInput {
  title: string
  description?: string
  ogTitle?: string
  ogDescription?: string
  ogUrl?: string
  ogSiteName?: string
  ogImage?: string
  twitterCard?: string
  twitterTitle?: string
  twitterDescription?: string
  twitterImage?: string
}

// TODO: obj로 받도록 수정
export const useMeta = (metaInput: ISeoMetaInput) => {
  const route = useRoute()
  const meta = ref({
    title: `${metaInput.title} | ${CHAIN} Community Hub`,
    description: metaInput.description ?? '',
    get ogTitle() {
      return metaInput.ogTitle ?? this.title
    },
    get ogDescription() {
      return metaInput.ogDescription ?? this.description
    },
    ogUrl: import.meta.env.VITE_APP_BASE_URL + route.fullPath,
    ogSiteName: `${CHAIN} Community Hub`,
    ogImage: metaInput.ogImage,
    twitterCard: 'summary_large_image',
    get twitterTitle ()  {
      return metaInput.twitterTitle ?? this.title
    },
    get twitterDescription () {
      return metaInput.twitterDescription ?? this.description
    },
    get twitterImage () {
      return metaInput.twitterImage ?? this.ogImage
    },
  })

  useSeoMeta(meta.value)
}